import { render } from "./industries.vue?vue&type=template&id=20f03c08&scoped=true&ts=true"
import script from "./industries.vue?vue&type=script&lang=ts"
export * from "./industries.vue?vue&type=script&lang=ts"

import "./industries.vue?vue&type=style&index=0&id=20f03c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f03c08"]])

export default __exports__